import React  from 'react';
import { Dialog, DialogContent, DialogTitle, Grid, IconButton, makeStyles, Paper, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    grid: {
        alignSelf: "center",
        padding: theme.spacing(1),
    },
    gridTable: {
        alignSelf: "center",
        padding: theme.spacing(1),
        minHeight: '300px'
    },
    dialogTitle: {
        background: theme.palette.primary.main,
        color: "#fff"
    },
    dialogClose: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "#fff"
    },
}));

export default function DialogComponent(props) {
    const classes = useStyles();

    const handleWindowClose = () => {
        props.handleClose();
    }

    return (
        <div className={classes.root}>
            <Dialog maxWidth="md" fullWidth aria-labelledby="dialog-title" open={props.open}>
                <DialogTitle disableTypography id="dialog-title" className={classes.dialogTitle} onClose={handleWindowClose}>
                    <Typography variant='h6'>{props.title}</Typography>
                    <IconButton className={classes.dialogClose} onClick={handleWindowClose}>
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Paper elevation={2}>
                        <Grid container>
                            <Grid item md={12} sm={12} className={classes.grid}>
                               {props.childComponent}
                            </Grid>
                        </Grid>
                    </Paper>
                </DialogContent>
            </Dialog>
        </div>
    )
}